/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Track_Import_LabelInputs */



/**
* | output |
* | --- |
* | "Assign To Track" |
*
* @param {Event_Track_Import_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_track_import_label = /** @type {((inputs?: Event_Track_Import_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Track_Import_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Attribuer au suivi")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dem Track zuweisen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Assegna al tracciamento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Назначить для отслеживания")
	if (locale === "es") return /** @type {LocalizedString} */ ("Asignar a la pista")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("分配至轨道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トラックに割り当てる")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ट्रैक को असाइन करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Atribuir à trilha")
	return /** @type {LocalizedString} */ ("Assign To Track")
});